module.exports = __webpack_public_path__ + "static/media/28.a9dbd6b1.jpeg";